/**
 * transfer-constants — Limits-SSOT für das Transfer-Feature (Spec T1).
 *
 * Zod-frei und client-safe: Sprint T2 (Dropzone-UI) importiert dieselben
 * Werte für Client-seitige Vor-Validierung + Zeichen-Counter. Der Server
 * bleibt die Enforcement-Grenze (413/400).
 *
 * Statuscode-Zuordnung (Spec Requirement 2):
 *   Datei-Cap / Gesamt-Cap / Anzahl-Cap  → 413
 *   invalide expiryDays / Message zu lang → 400
 */

/** Hard-Cap pro Datei: 10 GiB (User-Entscheid 2026-07-08; S3-Multipart nötig). */
export const TRANSFER_MAX_FILE_BYTES = 10 * 1024 ** 3;

/** Max. Dateien pro Transfer (20 → 50 am 2026-07-15: Ordner-Drops liefern
 * reale Druckdaten-Projekte mit >20 Dateien, User-Entscheid). */
export const TRANSFER_MAX_FILES = 50;

/** Max. Gesamtvolumen pro Transfer: 25 GiB. */
export const TRANSFER_MAX_TOTAL_BYTES = 25 * 1024 ** 3;

/** Wählbare Aufbewahrung in Tagen (analog Share-Expiry-Auswahl). */
export const TRANSFER_EXPIRY_DAYS = [7, 30] as const;
export type TransferExpiryDays = (typeof TRANSFER_EXPIRY_DAYS)[number];

/** Default-Aufbewahrung wenn der Client nichts wählt. */
export const TRANSFER_DEFAULT_EXPIRY_DAYS: TransferExpiryDays = 7;

/** Max. Länge der optionalen Empfänger-Nachricht (Sonnet-Spec-R1 F5). */
export const TRANSFER_MESSAGE_MAX_LENGTH = 500;

/** Optionaler Passwortschutz (WeTransfer-Stil). Min 4 (kurze Share-Passwörter
 * bewusst erlaubt — Brute-Force-Abwehr ist das Rate-Limit, nicht die Länge);
 * max 128 — bcrypt trunkiert zwar bei 72 Byte, der Max deckelt trotzdem gegen
 * DoS/UX-Unfug. Leerer/whitespace-Wert = kein Passwort. */
export const TRANSFER_PASSWORD_MIN = 4;
export const TRANSFER_PASSWORD_MAX = 128;

/** Transfer-Lifecycle (DB-CHECK-Parität, siehe schema.ts transfers_status_ck). */
export type TransferStatus = 'draft' | 'active' | 'revoked';
